<div class="custom-modal-container">
  <div class="custom-modal-container-content primary">
    <div (click)="onClose()" class="close-button" *ngIf="context && !context.isClose">
      <svg class="icon-svg">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dialog-cross"></use>
      </svg>
    </div>

    <div class="content-container">
      <i class="modal-icon">
        <svg class="icon-svg">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#404"></use>
        </svg>
      </i>
      <h2 class="modal-title">
        <span>{{ 'Oops!' | translate }}</span> <br />
        <span>{{ "The page you are looking for doesn't exist." | translate }}</span>
      </h2>

      <div class="button-container">
        <a class="primary-button" (click)="onClose()">{{ 'Get me outta here' | translate }}</a>
      </div>
    </div>
  </div>
</div>
